import React from 'react';

const Export = () => {
  return <div style={{ padding: 16 }}></div>;
};

export default Export;
